(function() {
  'use strict';
  
  angular
    .module('app.myPolls', []);
  
})();